import _ from "lodash"

export const getQueryIsLoading = state => _.get(state,['isLoading'],false)
export const getQueryIsSuccess = state => _.get(state,['isSuccess'],false)
export const getQueryData= state => _.get(state,['data'],[])